import React from 'react';
import { CaptureOverlay } from '../shared';
import type { ScreenMode } from './useScreenRecorder';

interface ScreenOptionsProps {
  taskName: string;
  mode: ScreenMode;
  enableMic: boolean;
  enableSystemAudio: boolean;
  onSetMode: (mode: ScreenMode) => void;
  onSetMic: (on: boolean) => void;
  onSetSystemAudio: (on: boolean) => void;
  onStartShare: () => void;
  onClose: () => void;
}

export const ScreenOptions: React.FC<ScreenOptionsProps> = ({
  taskName,
  mode,
  enableMic,
  enableSystemAudio,
  onSetMode,
  onSetMic,
  onSetSystemAudio,
  onStartShare,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      {/* Mode tabs */}
      <div style={{ display: 'flex', gap: 6, padding: '8px 12px 0', flexShrink: 0 }}>
        <button
          className={mode === 'screen-only' ? 'co-btn-circle-ember' : 'co-btn-circle-ghost'}
          style={{ width: 'auto', height: 'auto', borderRadius: 20, padding: '5px 12px', fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' as const }}
          onClick={() => onSetMode('screen-only')}
        >
          Screen Only
        </button>
        <button
          className={mode === 'screen-cam' ? 'co-btn-circle-ember' : 'co-btn-circle-ghost'}
          style={{ width: 'auto', height: 'auto', borderRadius: 20, padding: '5px 12px', fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' as const }}
          onClick={() => onSetMode('screen-cam')}
        >
          Screen + Cam
        </button>
      </div>

      <div className="sc-scroll-body">
        <div className="sc-options-card">
          <div className="sc-options-title">Recording options</div>

          {/* Mic toggle */}
          <div className="sc-toggle-row">
            <div>
              <div className="sc-toggle-label">Enable Microphone</div>
              <div className="sc-toggle-sub">Your voice will be recorded</div>
            </div>
            <div
              className={`sc-toggle ${enableMic ? 'sc-toggle-on' : 'sc-toggle-off'}`}
              onClick={() => onSetMic(!enableMic)}
            >
              <div className="sc-toggle-knob" />
            </div>
          </div>

          {/* Mic level (visual indicator) */}
          {enableMic && (
            <div className="sc-mic-section">
              <div className="sc-mic-label">Mic level</div>
              <div className="sc-mic-bars">
                {[14, 18, 22, 16, 12, 8, 6, 4].map((h, i) => (
                  <div
                    key={i}
                    className="sc-mic-bar"
                    style={{
                      height: h,
                      background: i < 5
                        ? (i === 2 ? 'var(--ember)' : 'var(--sage)')
                        : 'rgba(255,255,255,0.2)',
                    }}
                  />
                ))}
              </div>
            </div>
          )}

          {/* System audio toggle */}
          <div className="sc-toggle-row-last">
            <div>
              <div className="sc-toggle-label">Enable System Audio</div>
              <div className="sc-toggle-sub">Record app sounds</div>
            </div>
            <div
              className={`sc-toggle ${enableSystemAudio ? 'sc-toggle-on' : 'sc-toggle-off'}`}
              onClick={() => onSetSystemAudio(!enableSystemAudio)}
            >
              <div className="sc-toggle-knob" />
            </div>
          </div>
        </div>

        <button className="sc-btn-cta" onClick={onStartShare}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
          Start Screen Share
        </button>
        <div className="sc-hint">Your browser will ask you to choose what to share</div>
      </div>
    </CaptureOverlay>
  );
};
